import React, { Fragment, useState } from 'react';
import {
  Datagrid,
  FunctionField,
  ReferenceManyField,
  TextField,
  useDataProvider,
  useRefresh,
} from 'react-admin';
import EditButton from '../../EventSleuth/QuickEdit';
import { Pagination } from 'Components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentAltExclamation, faHandPointLeft, faStar } from '@fortawesome/pro-regular-svg-icons';
import { tabbedLists } from 'styles';
import { Button, Dialog, DialogTitle, Tooltip } from '@material-ui/core';

const SleuthTab = (props) => {
  const { record } = props;
  const classes = tabbedLists();
  const [loading, setLoading] = useState(false);
  const dataProvider = useDataProvider();

  const refresh = useRefresh();

  const [showDialog, setShowDialog] = useState(false);
  const [currentSleuth, setCurrentSleuth] = useState('');

  const openModal = (record) => {
    setShowDialog(true);
    setCurrentSleuth(record.evidence);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
    setCurrentSleuth('');
  }

  const handleAwardAll = () => {
    setLoading(true);
    dataProvider.getManyReference('eventSuperSleuth', {
      filter: { eventId: props.record.id },
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'orderIndex', order: 'ASC' },
    })
      .then(({ data }) => {

        // const updatePromises = data.map(element => {
        //   if (element.isSuperSleuth === 'No' && element.suspect && element.suspect.murderBoxChecked) {
        //     return dataProvider('UPDATE', 'EventSuperSleuth', { id: element.id })
        //       .catch((error) => {
        //         console.log(error);
        //       });
        //   }
        //   return Promise.resolve();
        // });
        // console.log(updatePromises);

        // return Promise.all(updatePromises);

        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          if (element.isSuperSleuth === 'No' && element.suspect && element.suspect.murderBoxChecked) {
            setTimeout(() => {
              dataProvider.update('eventSuperSleuth', { id: element.id }).then(() => {
              })
                .catch((error) => {
                  console.log(error);
                });
            }, i * 500); // 500ms delay between each request
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
        refresh();
      });
  };

  return (
    <Fragment>
      <div className={classes.actions}>
        <Button style={{
          marginTop: '35px',
          fontSize: '13px',
          color: '#243f56',
        }}
          onClick={handleAwardAll}>
          <FontAwesomeIcon icon={faStar} /> &nbsp; Award all
        </Button>
      </div >
      <ReferenceManyField
        reference="eventSuperSleuth"
        target="eventId"
        source="id"
        sort={{ field: 'priorityNumber', order: 'ASC' }}
        pagination={<Pagination />}
        perPage={50}
      >
        <Datagrid>
          <TextField source="sleuthName" sortable={false} />
          <FunctionField label={'Name'}
            render={(record) => <div> {record.suspectName} {record.suspect.murderBoxChecked ? <FontAwesomeIcon icon={faHandPointLeft} /> : ''} </div>}
            sortable={false} />
          <TextField
            source="isSuperSleuth"
            label="Super Sleuth"
            sortable={false}
          />
          <TextField
            source="isIntentional"
            label="Intentional"
            sortable={false}
          />
          <FunctionField
            source="evidence"
            label="Evidence"
            sortable={false}
            render={(record) => {
              let content = record.evidence ? record.evidence : '';
              return (
                <Tooltip title={content} placement='top'>
                  <div onClick={() => openModal(record)}>
                    {content.length < 20 ? content : content.substring(0, 20) + '...'}
                  </div>
                </Tooltip>
              )
            }}
          />
          <FunctionField render={(record) => <EditButton record={record} />} />
        </Datagrid>
      </ReferenceManyField>

      <Dialog open={showDialog} fullWidth
        onClose={handleCloseClick}
        aria-label={`Feedback detail`}
      >
        <DialogTitle id="alert-dialog-title">
          Sleuth evidence detail
        </DialogTitle>
        <div style={{ padding: '16px 24px' }}>
          {currentSleuth}
        </div>
      </Dialog>
    </Fragment>
  );
};

export default SleuthTab;
